module.exports = __webpack_public_path__ + "img/bandaoti_zhihuiyungang_suoluetu.8e32b3ff.png";